export function getDoorAccessesByCommunityId(doorAccesses = {}, maybeParsedCommunityId = 0) {
  const communityId = parseInt(maybeParsedCommunityId, 10)

  const communityDoorAccesses = {}
  Object.entries(doorAccesses).forEach(([k, v]) => {
    if (v.parent_community_id === communityId) {
      communityDoorAccesses[k] = v
    }
  })

  return communityDoorAccesses
}

export function credentialsComparator(a, b) {
  const acard = a.card || ''
  const bcard = b.card || ''
  const apin = a.pin || ''
  const bpin = b.pin || ''
  return acard.localeCompare(bcard) || apin.localeCompare(bpin)
}
